<script>
	import { mapState, mapGetters } from "vuex";

	export default {
		data() {
			return {
				leftover: this.convertNumberToString(0, 2),
				totalInclTax: 0
			};
		},
		computed: {
			...mapGetters(["totals", "currency"]),
			...mapState({
				page: state => state.page,
				downpayment: state => state.downpayment,
				downpaymentInclTax: state => state.downpayment.downpayment.totals.inclTax,
				couponCodeAmount: state => state.vat.couponCodeAmount,
				selectedVatValue: state => state.vat.selectedVatValue
			}),
			depositValue: {
				get() {
					return this.$store.state.downpayment.depositValue;
				},
				set(value) {
					this.$store.commit("depositValue", value);
				}
			},
			depositPercent: {
				get() {
					return this.$store.state.downpayment.depositPercent;
				},
				set(value) {
					this.$store.commit("depositPercent", value);
				}
			},
			depositAmount: {
				get() {
					return this.$store.state.downpayment.depositAmount;
				},
				set(value) {
					this.$store.commit("depositAmount", value);
				}
			},
			monitor() {
				return {
					table: this.totals.table,
					couponCodeAmount: this.couponCodeAmount
				};
			}
		},
		watch: {
			monitor: {
				handler() {
					if (this.totals.table.inclTax > 0) {
						const _couponCodeValue = this.convertStringToNumber(this.couponCodeAmount);
						const _selectedVatValue = this.convertStringToNumber(this.selectedVatValue);

						const _inclTax =
							this.totals.table.inclTax -
							(_couponCodeValue + (_couponCodeValue * _selectedVatValue) / 100);

						this.totalInclTax = _inclTax - this.downpaymentInclTax / 100;

						this.onChangeDepositPercent();
						this.onChangeDepositAmount();
					}
				},
				deep: true,
				immediate: true,
			},
			downpaymentInclTax() {
				if (this.downpaymentInclTax > 0) {
					const _couponCodeValue = this.convertStringToNumber(this.couponCodeAmount);
					const _selectedVatValue = this.convertStringToNumber(this.selectedVatValue);

					const _inclTax =
						this.totals.table.inclTax - (_couponCodeValue + (_couponCodeValue * _selectedVatValue) / 100);

					this.totalInclTax = _inclTax - this.downpaymentInclTax / 100;

					this.onChangeDepositPercent();
					this.onChangeDepositAmount();
				}
			},
			depositPercent() {
				this.onChangeDepositPercent();
			},
			depositAmount() {
				this.onChangeDepositAmount();
			},
			depositValue: {
				handler() {
					const _depositValue = this.depositValue;

					this.leftover = this.convertNumberToString(_depositValue);
				},
				immediate: true
			}
		},
		methods: {
			onChangeDepositPercent() {
				const _depositPercent = this.convertStringToNumber(this.depositPercent);
				if (!this.empty(_depositPercent)) {
					const _totalInclTax = this.convertStringToNumber(this.totalInclTax);
					
					this.depositAmount = null;

					const amount = (_totalInclTax * _depositPercent) / 100;

					if (_depositPercent > 0 && amount > 0) {
						this.leftover = amount;
					} else {
						this.leftover = "0,00";
					}
				}
			},
			onChangeDepositAmount() {
				const _depositAmount = this.convertStringToNumber(this.depositAmount);
				if (!this.empty(_depositAmount)) {
					const _totalInclTax = this.convertStringToNumber(this.totalInclTax);
					
					let amount = null;
					this.depositPercent = null;

					if (this.page.type === "invoices") {
						amount = _totalInclTax - _depositAmount;
					} else {
						amount = _depositAmount;
					}

					if (_depositAmount > 0 && amount > 0) {
						this.leftover = amount;
					} else {
						this.leftover = "0,00";
					}
				}
			},
			empty(val) {
				if (val === null || val === undefined)	return true
				else if (parseFloat(val) === 0.0) return true
				else return false
			}
		}
	};
</script>

<template>
	<div>
		{{ $t("Acompte de") }}
		<b-form-input
			v-model.lazy="depositPercent"
			lazy-formatter
			:formatter="convertNumberToString"
			class="
				input-sinao
				billing__input billing__input-inline billing__input--minwidth billing__input--solid
				text-right
			"
			style="height: 32px; width: 57px"
			@focus="$event.target.select()"
		/>%
		<span>
			(
			<b-form-input
				v-model.lazy="depositAmount"
				:placeholder="convertNumberToString(0, 2)"
				lazy-formatter
				:formatter="convertNumberToString"
				class="
					billin_input--solid
					billing__input billing__input-inline billing__input--minwidth billing__input--solid
					text-right
				"
				style="height: 32px; width: 57px"
				@focus="$event.target.select()"
			/>
			{{ currency }})
		</span>

		<span v-if="page.type === 'invoices'">{{ $t("versé, soit un restant dû de") }}</span>
		<span v-else>
			{{
				page.type !== "invoices" && page.type === "quotes" && empty(convertStringToNumber(depositAmount)) && !empty(convertStringToNumber(depositPercent))
					? $t("à régler à la commande, soit")
					: $t("à régler à la commande.")
			}}
		</span>

		<span
			v-if="page.type === 'invoices' || (page.type === 'quotes' && empty(convertStringToNumber(depositAmount)) && !empty(convertStringToNumber(depositPercent)))"
			class="text-medium"
		>
			{{ leftover | convertNumberToString(2) }}{{ currency }}.
		</span>
	</div>
</template>

<style></style>
